<template>
	<div class="homeBottom">
		<div class="assTop">
			<div class="spanFrame">
				<div v-for="(item, index) in labelArray" :key="index" class="spanChild">
					<div class="spanLabel">
						<span>{{ item.label }}</span>
					</div>
					<div class="spanContent" v-for="(res, resindex) in item.child" :key="resindex">
						<div>
							<span>{{ res.label }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="imgFrame">
				<div class="imgFrameLogo">
					<img src="../assets/logo.png" class="imgStyle" />
				</div>
				<div class="p-marginTop10">
					<span>山 哩 数 智 科 技 有 限 公 司 官 网</span>
				</div>
				<div class="p-marginTop10">
					<span>SHANLI HOLDING TECHNOLOGY</span>
				</div>
			</div>
			<div class="aboutUs" v-for="(item, index) in aboutArray" :key="index">
				<div class="aboutUsFrame">
					<div class="labelFrame">
						{{ item.label }}
					</div>
					<div class="aboutUsImg">
						<img :src="item.src" class="imgStyle" />
					</div>
				</div>
			</div>
		</div>
		<div class="assfooter">
			<span>版权所有：山哩数智科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">黔ICP备2022006061号</a> </span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				copyright: "",
				labelArray: [{
						label: "新手上路",
						child: [{
							label: "用户注册"
						}, {
							label: "密码找回"
						}, {
							label: "用户注册协议"
						}]
					},
					{
						label: "用户中心",
						child: [{
							label: "如何发布货源"
						}, {
							label: "如何获取产品源"
						}, {
							label: "如何进行交易"
						}]
					},
					{
						label: "电商服务",
						child: [{
							label: "客服服务"
						}, {
							label: "物流服务"
						}, {
							label: "商城"
						}]
					}
				],
				aboutArray: [
					// { label: "山哩APP", src: require("@/assets/qrCode.png") },
					{
						label: "微信公众号",
						src: require("@/assets/gzh.jpg")
					}
				]
			}
		}
	}
</script>

<style scoped>
	.homeBottom {
		height: 100%;
		width: 100%;
		background-color: rgba(30, 33, 37, 100);
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.assTop {
		display: flex;
		height: 85%;
		width: 55%;
		align-items: center;
		justify-content: space-between;
	}

	.assfooter {
		height: 15%;
		width: 100%;
		background-color: #21282F;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-size: 0.9rem;
		letter-spacing: 0.5rem;
	}

	.spanFrame {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-size: 10px;
	}

	.spanChild {
		margin: 10px 20px;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
	}

	.spanLabel {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 8px;
		border-bottom: 1px #0476FF solid;
	}

	.spanContent:nth-child(1) {
		margin: 15px 10px;
		display: flex;
		justify-content: center;
	}

	.spanContent {
		margin-top: 20px;
	}

	.imgStyle {
		height: 100%;
		width: 100%;
	}

	.imgFrame {
		display: flex;
		color: #fff;
		flex-direction: column;
		align-items: center;
	}

	.imgFrameLogo {
		height: auto;
		width: 15%
	}

	.aboutUs {
		color: #fff;
	}

	.aboutUsFrame {
		color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.aboutUsImg {
		margin: 10px 0px;
		height: 80px;
		width: 80px;
	}

	.labelFrame {
		font-size: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/assembly/homeBottom.vue